import { useEffect, useState } from "react"
import { UserApi } from "../../api/User.api"
import HistoryItem from "../../components/payment-history/History.item"
import PaymentHistory from "../../models/PaymentHistory.model"
import { Container } from "./style"
import { PAYMENT_STATUS } from "../../commons/Const"

export default function PaymentHistoryPage() {

  const [paymentHistoryList, setPaymentHistoryList] = useState<PaymentHistory[]>([])

  useEffect(() => {
    getPaymentHistoryList()
  }, [])  

  const getPaymentHistoryList = () => {
    UserApi.getPaymentHistoryList({
      paymentStatus: [PAYMENT_STATUS.SUCCESS, PAYMENT_STATUS.CANCEL].join(',')
    })
    .then(results => {
      setPaymentHistoryList(results)
    }).catch(console.error)
  }

  return (
    <Container>
      <div className="inner page_inner">
        <p className="page_title"><span>결제 내역</span></p>

        <section>
          {paymentHistoryList.map((history, index) => (
            <HistoryItem key={`history${index}`}
              history={history}
            />
          ))}
        </section>
      </div>
    </Container>
  )
}